// utils
import PadEditorPrescriptionMedicament from '../components-js/pad-prescription/PadPrescriptionMedicament';

const TEMPLATE_NAME = 'PAD_EDITOR_PRESCRIPTION_MEDICAMENT';

const initialState = {
  errors: [],
  data: {
    current: [],
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padEditorPrescription = new PadEditorPrescriptionMedicament(state);

      return padEditorPrescription.setLoading().setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { currentPadPrescriptionMedicament, previousPadPrescriptionMedicament } =
        action.payload;

      const padEditorPrescription = new PadEditorPrescriptionMedicament(state);

      return padEditorPrescription
        .prepare(currentPadPrescriptionMedicament, previousPadPrescriptionMedicament)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padEditorPrescription = new PadEditorPrescriptionMedicament(state);

      return padEditorPrescription.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const prescriptionForm = action.payload.data;
      const padEditorPrescription = new PadEditorPrescriptionMedicament(state);

      // prettier-ignore
      return padEditorPrescription
        .add(prescriptionForm)
        .replacesAllPrescriptors(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padEditorPrescription = new PadEditorPrescriptionMedicament(state);

      // prettier-ignore
      return padEditorPrescription
      .edit(code, prescriptionForm)
      .replacesAllPrescriptors(prescriptionForm)
      .getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padEditorPrescription = new PadEditorPrescriptionMedicament(state);

      // prettier-ignore
      return padEditorPrescription
        .remove(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_SUSPEND`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadEditorPrescriptionMedicament(state);

      // prettier-ignore
      return padCreatorPrescription
        .suspend(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_UNSUSPEND`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadEditorPrescriptionMedicament(state);

      // prettier-ignore
      return padCreatorPrescription
        .unsuspend(code, prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_CHANGE_STATUS`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadEditorPrescriptionMedicament(state);

      // prettier-ignore
      return padCreatorPrescription
        .changeStatus(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
